if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form?.querySelector('[name=id]')) this.form.querySelector('[name=id]').disabled = false;
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-items');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer'))
          this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        if (this.querySelector('.back-in-stock-form') != undefined) {
          this.renderBackInStock();
        }
      }

      renderBackInStock() {
        this.bisBtn = this.querySelector('.back-in-stock-form');
        this.bisBtnId = this.bisBtn?.dataset.modal;
        this.bisModalContent = document.querySelector(
          `${this.bisBtn.dataset.modal}`
        );

        if (this.bisModalContent == undefined || this.bisModalContent == null) {
          return;
        }

        this.bisSubmitBtn =
          this.bisModalContent.querySelector('.bis-submit-btn');
        this.bisEmailInput = this.bisModalContent.querySelector('.bis-email');
        this.bisSuccessMsg =
          this.bisModalContent?.querySelector(
            '.bis-success-msg'
          ).dataset.bisSuccessMsg;
        this.bisMessage = this.bisModalContent.querySelector('.bis-message');

        this.bisSubmitBtn?.addEventListener('click', () => {
          const productId = parseInt(this.bisSubmitBtn.dataset.productId);
          const variantId = parseInt(this.bisSubmitBtn.dataset.variantId);
          const email = this.bisSubmitBtn.dataset.emailInput;
          const bisListId = this.bisSubmitBtn.dataset.bisListId;
          const apiKey = this.bisSubmitBtn.dataset.apiKey;
          const data = {
            a: apiKey,
            email: email,
            platform: 'shopify',
            variant: variantId,
            product: productId,
            list: bisListId,
          };
          this.subscribeToNotification(data);
        });

        this.bisEmailInput?.addEventListener('change', () => {
          this.emailCheck();
        });

        this.bisEmailInput?.addEventListener('keyup', () => {
          this.emailCheck();
        });
      }

      emailCheck() {
        this.bisSubmitBtn.dataset.emailInput = this.bisEmailInput.value;
        if (!this.bisSubmitBtn.dataset.emailInput.includes('@')) {
          this.bisSubmitBtn.setAttribute('disabled', true);
        } else {
          this.bisSubmitBtn.removeAttribute('disabled');
        }
      }

      subscribeToNotification(data) {
        fetch(
          'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
          {
            headers: {
              accept: 'application/json',
              'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: new URLSearchParams(data),
            method: 'POST',
          }
        )
          .then((response) => {
            this.bisMessage.innerHTML = `
              <h6>${this.bisSuccessMsg}</h6>
            `;
          })
          .catch((err) => {
            this.bisMessage.innerHTML = `
              <h6>${this.bisSuccessMsg}</h6>
            `;
            console.log("Back in stock error", err);
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.addItem();
      }

      addItem() {
        this.handleErrorMessage();

        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading-overlay__spinner')) {
          this.querySelector('.loading-overlay__spinner').classList.remove(
            'hidden'
          );
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          let sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);
          if (this.cartItems) {
            sections = [
              ...new Set(
                sections.concat(
                  this.cartItems
                    .getSectionsToRender()
                    .map((section) => section.section)
                )
              ),
            ];
          }
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let cartDrawerItems = document.querySelector('cart-drawer-items');
        let freeSubscriptionVariantAlreadyInCart =
          cartDrawerItems?.dataset.cartFreeSubscriptionItems?.includes(
            formData.get('id')
          );

        if (freeSubscriptionVariantAlreadyInCart) {
          let subscriptionPrice = parseInt(formData.get('subscription_price'));
          let sellingPlan = formData.get('selling_plan');

          if (sellingPlan != null && subscriptionPrice == 0) {
            formData.delete('selling_plan');
          }
        }

        // 1+1 campaign doubling: round qty up to nearest even, skip subscriptions
        if (this.dataset.doubling === 'true' && !formData.get('selling_plan')) {
          const qty = parseInt(formData.get('quantity') || '1', 10);
          formData.set('quantity', qty % 2 === 0 ? qty : qty + 1);
        }

        config.body = formData;

        // script for handling adding free product to cart

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton?.setAttribute('aria-disabled', true);
              this.submitButton?.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.checkVariantUpsell(this.form, this.cart, response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.checkVariantUpsell(this.form, this.cart, response);
            }

            const event = new CustomEvent('cart:add', {
              detail: {
                cartData: response,
                productForm: this.form,
              }
            });

            document.dispatchEvent(event);
            this.getCartContents()
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.querySelector('.loading-overlay__spinner')) {   
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden'
              );
            }
          });
      }

      async getCartContents() {
        let cartContents;
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart.js');
          const data = await response.json();
          cartContents = data;
          const event = new CustomEvent('cart:update', {
            detail: { cartState: cartContents },
          });
          document.dispatchEvent(event);
        } catch (error) {
          console.log(error);
        }
        return cartContents;
      }

      // isFreeGiftInCart(cartItems, giftVariantIdsArr) {
      //   let cartItemsArr = cartItems.map((item) => item.id);
      //   // check cart items against free gift variant ids
      //   for (let ii = 0; ii < cartItemsArr.length; ii++) {
      //     for (let jj = 0; jj < giftVariantIdsArr.length; jj++) {
      //       if (cartItemsArr[ii] == giftVariantIdsArr[jj]) {
      //         return true;
      //       }
      //     }
      //   }
      //   return false;
      // }

      // handleGiftProduct(cart, giftVariantIdToAdd, giftVariantIdToRemove) {
      //   let data = {
      //     sections: 'cart-drawer,cart-icon-bubble',
      //     updates: {},
      //   };

      //   let cartContents = document.getElementById('CartDrawerContent')
      //     ? JSON.parse(document.getElementById('CartDrawerContent').textContent)
      //     : undefined;
      
      //   if (giftVariantIdToAdd && ((!window.gift_campaigns.min_order_value) || (window.gift_campaigns.min_order_value && window.gift_campaigns.min_order_value <= cartContents.total_price))) {
      //     data.updates[giftVariantIdToAdd] = 1;
      //   }

      //   if (giftVariantIdToRemove && ((!window.gift_campaigns.min_order_value) || (window.gift_campaigns.min_order_value && window.gift_campaigns.min_order_value > cartContents.total_price))) {
      //     data.updates[giftVariantIdToRemove] = 0;
      //   }

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   config.body = JSON.stringify(data);
      //   config.method = 'POST';
      //   fetch(`${routes.cart_update_url}`, config)
      //     .then((res) => res.json())
      //     .then((res) => cart.renderContents(res))
      //     .catch((e) => {
      //       console.error(e);
      //     });
      // }

      checkVariantUpsell(form, cart, response) {
        if (
          form.querySelector('[name=id]').dataset.upsellOtherVariants ==
            'true' &&
          form.querySelector('[name=id]').dataset.otherVariantsAvailable ==
            'true' &&
          sessionStorage.getItem('upsell') == null
        ) {
          this.runVariantsUpsell(response);
        } else {
          if (
            form.dataset.variantUpsell == 'true' &&
            sessionStorage.itemQty != null &&
            sessionStorage.itemToRemove != null
          ) {
            let data = {
              id: sessionStorage.itemToRemove,
              quantity: parseInt(sessionStorage.itemQty) - 1,
              sections: 'cart-drawer,cart-icon-bubble',
            };
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.body = JSON.stringify(data);
            config.method = 'POST';
            fetch(`${routes.cart_change_url}`, config)
              .then((res) => res.json())
              .then((res) => {
                if (res.status) {
                  alert(res.description);
                  return;
                }
                cart.renderContents(res);
                sessionStorage.setItem('upsellResponse', 'true');
              })
              .catch((e) => {
                console.error(e);
              });
          } else {
            if (this.cartItems) {
              this.cartItems.renderContents(response);
            }
            this.cart.renderContents(response);
          }
        }
      }

      runVariantsUpsell(response) {
        sessionStorage.setItem('upsell', 'true');
        sessionStorage.setItem('itemToRemove', `${response.key}`);
        sessionStorage.setItem('itemQty', `${response.quantity}`);
        const upsellVariantPopup = document.getElementById(
          'PopupModal-upsell-variants'
        );
        const upsellPopupContent = upsellVariantPopup.querySelector(
          '.product-popup-modal__content'
        );
        upsellVariantPopup.setAttribute('open', '');
        const refuseBtns =
          upsellVariantPopup.querySelectorAll('.refuse-button');

        // if declined, view cart content on click of refuse buttons
        refuseBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.cart.renderContents(response);
            sessionStorage.setItem('upsellResponse', 'true');
          });
        });

        // if click outside of upsell popup, view cart immediately
        document.addEventListener('click', (e) => {
          if (
            !upsellPopupContent.contains(e.target) &&
            sessionStorage.getItem('upsellResponse') == null
          ) {
            this.cart.renderContents(response);
            sessionStorage.setItem('upsellResponse', 'true');
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  let variantRadiosInputs = document.querySelectorAll('variant-radios');
   variantRadiosInputs?.forEach((radio) => radio.classList.remove('is-loading'))
});
